import React from 'react'
import { Helmet } from 'react-helmet'

interface Props {
  title: string
}

export const Metadata: React.FC<Props> = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}
